import { ChangeDetectionStrategy, Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { createForm, createFormControl, SubFormGroup, TypedFormGroup } from 'osn-shared';
import { TrayControlValueAccessorBase } from '../../../create-tray-screen/components/tray-control-value-accessor-base';
import { FileUploadDataViewModel } from '../../../file-upload/components/file-upload.view-model';
import { LocalizedFileUploadDataViewModel } from './image-upload-view-model';

type FormModel = Record<string, LocalizedFileUploadDataViewModel>;
type FormControls = SubFormGroup<FormModel>;

@Component({
  selector: 'osn-cxb-image-upload-control',
  templateUrl: './image-upload-control.component.html',
  styleUrls: ['./image-upload-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ImageUploadControlComponent), multi: true }],
})
export class ImageUploadControlComponent extends TrayControlValueAccessorBase<FormModel, FormControls> implements OnInit {
  @Input() public imageUploadConfigs: Record<string, LocalizedFileUploadDataViewModel>;
  @Input() public layoutDirection: 'vertical' | 'horizontal' = 'vertical';
  @Input() public showPlatformNames = true;
  @Input() public showImageColumnTitles = false;
  @Input() public required: boolean;
  @Input() public hasDeleteOption = false;
  @Input() public isImageAlreadyBelongsToResource = false;

  public configEntries: [string, LocalizedFileUploadDataViewModel][];

  constructor() {
    super();
  }

  protected getDefaultVm(): FormModel {
    const defaultVm = {};
    Object.keys(this.imageUploadConfigs).forEach((key) => {
      defaultVm[key] = {
        ar: undefined,
        en: undefined,
      };
    });
    return defaultVm as FormModel;
  }

  protected initForm(value: FormModel) {
    const formValue = {
      ...this.getDefaultVm(),
      ...value,
    };

    this.form = this.createImagesFormGroup(formValue);
    this.configEntries = Object.entries(this.imageUploadConfigs) as [
      string,
      { en: FileUploadDataViewModel; ar?: FileUploadDataViewModel }
    ][];
  }

  protected mapFormValueToEmittedValue(value: FormModel): FormModel {
    return { ...value };
  }

  private createImagesFormGroup(formValue: FormModel): TypedFormGroup<FormModel> {
    this.formControls = {} as FormControls;
    Object.keys(formValue).forEach((key) => {
      this.formControls[key] = createForm({
        en: createFormControl(formValue[key].en, Validators.required),
        ar: createFormControl(formValue[key].ar, this.imageUploadConfigs[key].ar ? [Validators.required] : []),
      });
    });
    return createForm(this.formControls);
  }
}
